export const SET_IS_ONLINE = 'misc/SET_IS_ONLINE';

export default {}; // eslint no likey no default
